import React from "react";
import { Card, CardContent } from "./ui/card";
import { partners } from "../mock";
import { useLanguage } from "../contexts/LanguageContext";

const Partners = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            {t('ourPartners')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('partnersDescription')}
          </p>
        </div>

        {/* Partners grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {partners.map((partner, index) => (
            <Card key={index} className="group hover:shadow-lg transition-all duration-300 border border-gray-100">
              <CardContent className="p-6 text-center">
                {/* Partner logo placeholder */}
                <div className="w-16 h-16 bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg mx-auto mb-4 flex items-center justify-center group-hover:from-orange-100 group-hover:to-orange-200 transition-all duration-300">
                  <span className="text-2xl font-bold text-gray-600 group-hover:text-orange-500">
                    {partner.name.charAt(0)}
                  </span>
                </div>
                
                <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-orange-500 transition-colors duration-300">
                  {partner.name}
                </h3>
                <p className="text-xs text-gray-500 leading-tight">
                  {partner.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats section */}
        <div className="mt-20 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-12 text-white">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl lg:text-4xl font-bold mb-2">500+</div>
              <p className="text-blue-100">{t('satisfiedClients')}</p>
            </div>
            <div>
              <div className="text-3xl lg:text-4xl font-bold mb-2">20+</div>
              <p className="text-blue-100">{t('documentTypes')}</p>
            </div>
            <div>
              <div className="text-3xl lg:text-4xl font-bold mb-2">99%</div>
              <p className="text-blue-100">{t('successfulApplications')}</p>
            </div>
            <div>
              <div className="text-3xl lg:text-4xl font-bold mb-2">24ч</div>
              <p className="text-blue-100">{t('averageResponseTime')}</p>
            </div>
          </div>
        </div>

        {/* Security warning */}
        <div className="mt-16 bg-amber-50 border border-amber-200 rounded-2xl p-8">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold text-amber-800 mb-4">
              {t('beCareful')}
            </h3>
            <p className="text-amber-700">
              {t('securityWarning')}
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              "Не имеют рекомендаций",
              "Просят предоставить печати", 
              "Предлагают низкие цены",
              "Обещают нереальные сроки"
            ].map((warning, index) => (
              <div key={index} className="bg-white p-4 rounded-lg border border-amber-200">
                <p className="text-sm font-medium text-amber-800">❌ {warning}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-6">
            <p className="text-sm text-amber-700 font-medium">
              ✅ {t('workWithAuthentic')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;